const pt = {
    nav: {
        home: 'Início',
        aboutUs: 'Sobre Nós',
        services: 'Serviços',
        pages: 'Páginas',
        pricing: 'Preços',
        team: 'Equipa',
        faq: 'FAQ',
        blog: 'Blog',
        blogList: 'Lista do Blog',
        blogDetail: 'Detalhes do Blog',
        contactUs: 'Contacto',
        login: 'Iniciar Sessão',
    },

    footer: {
        callNow: 'Ligue Agora',
        aboutUsTitle: 'Sobre Nós',
        aboutUsText: 'A Pure Key Homes é o seu parceiro de confiança para gestão de imóveis e serviços para hóspedes. Dedicamo-nos a proporcionar tranquilidade, comodidade e cuidado profissional para os proprietários e os seus hóspedes.',
        contactUsNow: 'Contacte-nos Agora',
        ourLinks: 'Nossas Ligações',
        ourServices: 'Nossos Serviços',
        propertyManagement: 'Gestão de Imóveis',
        keyHolding: 'Guarda de Chaves',
        meetAndGreet: 'Receção de Hóspedes',
        cleaningService: 'Serviço de Limpeza',
        laundryService: 'Serviço de Lavandaria',
        propertyCheck: 'Revisão do Imóvel',
        contactUsTitle: 'Contacto',
        privacyPolicy: 'Política de Privacidade',
        termsOfService: 'Termos de Serviço',
        legal: 'Legal',
        copyright: 'Direitos de Autor © {{year}} Pure Key Homes. Todos os direitos reservados.',
    },

    home: {
        bannerTitle: 'A Sua Gestão de Imóveis na Costa Cálida e Costa Blanca Sur.',
        bannerPlaceholder: 'Email ou número de telefone...',
        bannerButton: 'Quero ser contactado',
        servicesSubtitle: 'SERVIÇOS',
        servicesTitle: 'O Que Oferecemos',
        testimonialSubtitle: 'TESTEMUNHO',
        testimonialTitle: 'O Que Dizem os Nossos Clientes',
        faqSubtitle: 'FAQ',
        faqTitle: 'Perguntas Comuns Sobre Gestão de Imóveis',
    },

    features: {
        subtitle: 'CARACTERÍSTICAS',
        title: 'Por Trás da História',
        description: 'Somos uma equipa de gestão de imóveis na Costa Cálida e Costa Blanca, oferecendo serviços personalizados, fiáveis e transparentes para proteger o seu investimento e garantir uma excelente experiência para os seus hóspedes.',
        fullPropertyManagement: 'Gestão Completa do Imóvel',
        fullPropertyManagementDesc: 'Serviço de receção de hóspedes, comunicação contínua com os hóspedes e gestão completa do imóvel entre reservas.',
        cleaningAndLaundry: 'Serviço de Limpeza e Lavandaria',
        cleaningAndLaundryDesc: 'Limpeza profissional e lavandaria entre estadias',
        guestCommunication: 'Comunicação com Hóspedes 24/7',
        guestCommunicationDesc: 'Comunicação com os hóspedes antes, durante e após a estadia',
        readMore: 'Ler Mais',
    },

    aboutBlog: {
        subtitle: 'SOBRE NÓS',
        title: 'Gerimos o Seu Imóvel',
        description: 'Desde a chegada do hóspede até à sua saída, tratamos de tudo — presencialmente, no local, e com total transparência. Para que desfrute do seu imóvel sem preocupações.',
        reservationManagement: 'Gerimosnos as suas reservas de início a fim',
        keyHolding247: 'Guarda segura de chaves, disponível 24/7',
        cleaningService: 'Limpeza profissional entre cada estadia',
        laundryService: 'Roupa de cama e toalhas sempre prontas',
        propertyCheckAlarm: 'Revisões do imóvel e resposta a alarmes 24/7',
        readMore: 'Ler Mais',
    },

    withUs: {
        subtitle: 'Fique em Contacto com Nós',
        title: 'Deseja gerir o seu imóvel com confiança? Contacte-nos hoje e discutamos como podemos ajudar.',
        contactUsNow: 'Contacte-nos Agora',
    },

    servicesList: {
        propertyManagement: 'Gestão de Imóveis',
        propertyManagementDesc: 'Gerimosnos o seu imóvel com comunicação com hóspedes, check-in/out, limpeza, manutenção e guarda de chaves, garantindo que o seu investimento esteja protegido',
        meetAndGreet: 'Receção de Hóspedes',
        meetAndGreetDesc: 'Recebemos pessoalmente os seus hóspedes, mostramos-lhes o imóvel e proporcionamos toda a informação necessária para uma estadia convolável.',
        cleaningService: 'Serviço de Limpeza',
        cleaningServiceDesc: 'Proporcionamos limpeza profissional entre as estadias dos hóspedes, garantindo que o seu imóvel esteja impecável, higienizado e pronto.',
        laundryService: 'Serviço de Lavandaria',
        laundryServiceDesc: 'O nosso serviço de lavandaria garante que todas as roupas de cama e toalhas estejam frescas, limpas e perfeitamente preparadas para cada hóspede.',
        keyHolding: 'Guarda de Chaves',
        keyHoldingDesc: 'Serviços seguros de gestão e entrega de chaves para garantir um check-in e check-out sem problemas para cada hóspede.',
        mortgage: 'Hipoteca',
        mortgageDesc: 'Financiamento para um novo investimento em imóvel.',
        support247: 'Apoio 24x7',
        support247Desc: 'De dia ou de noite, estamos aqui para gerir o seu imóvel e responder rapidamente a qualquer situação.',
        webDevelopment: 'Desenvolvimento Web',
        webDevelopmentDesc: 'Com o nosso serviço de Gestão Completa do Imóvel, oferecemos um sítio web completamente personalizado para o seu imóvel.',
        exploreAllServices: 'Ver Todos os Serviços',
    },

    priceList: {
        subtitle: 'PLANO DE PREÇOS',
        title: 'Escolha o Seu Plano',
        startingFrom: 'Preços a partir de apenas €15/mês — planos flexíveis adaptados às necessidades do seu imóvel.',
        getStarted: 'Começar',
        mostPopular: 'Mais Popular',
        keyHolding: 'Guarda de Chaves',
        keyHoldingDesc: 'Armazenamento seguro de chaves e gestão de acesso',
        keyHoldingFeatures: ['Armazenamento seguro de chaves', 'Disponibilidade 24/7', 'Coordenação de acesso ao imóvel', 'Check-in/out de hóspedes', 'Acesso de emergência'],
        propertyManagement: 'Gestão de Imóveis',
        propertyManagementDesc: 'Cuidado completo do imóvel',
        propertyManagementFeatures: ['Inspeções do imóvel', 'Coordenação de manutenção', 'Resposta a emergências', 'Relatórios mensais', 'Pagamentos de faturas'],
        cleaningService: 'Serviço de Limpeza',
        cleaningServiceDesc: 'Limpeza profissional do imóvel',
        cleaningServiceFeatures: ['Limpeza profunda', 'Limpeza pós-arrendamento', 'Manutenção regular', 'Produtos ecológicos', 'Serviço de roupa disponível'],
        laundryService: 'Serviço de Lavandaria',
        laundryServiceDesc: 'Lavandaria profissional e cuidado de roupa',
        laundryServiceFeatures: ['Lavar e dobrar', 'Mudança de roupa de cama', 'Serviço de passagem a ferro', 'Entrega rápida', 'Entrega incluída'],
    },

    touchStart: {
        subtitle: 'CONTACTO',
        title: 'Gerimos a sua propriedade com facilidade',
        panelSub: 'Estamos aqui para ajudar em cada passo do caminho.',
        panelPhone: 'Telefone',
        panelEmail: 'Correio eletrónico',
        panelLocation: 'Localização',
        panelLocationValue: 'Los Alcazares, Murcia, Espanha',
        panelHours: 'Horário',
        panelHoursValue: 'Seg – Dom: 24h/7',
        firstName: 'Nome',
        lastName: 'Apelido',
        emailAddress: 'Endereço de Correio Eletrónico',
        phoneNumber: 'Número de Telefone',
        selectCountryCode: 'Selecione código do país...',
        message: 'Mensagem...',
        submitNow: 'Enviar Agora',
        submitting: 'A enviar...',
        formSuccess: 'Sucesso!',
        formSuccessText: 'Obrigado por nos contactar! Responderemos dentro de 24 horas.',
        errorInvalidEmail: 'Por favor, introduza um endereço de e-mail válido (ex., nome@exemplo.com)',
        errorInvalidPhone: 'Por favor, introduza um número de telefone válido (6-15 dígitos)',
        errorRequiredField: 'Este campo é obrigatório',
        errorValidationTitle: 'Por Favor Verifique as Suas Informações',
        errorValidationMessage: 'Por favor, corrija os erros destacados e tente novamente.',
        errorTitle: 'Não Foi Possível Enviar a Mensagem',
        errorMessage: 'Não conseguimos enviar a sua mensagem. Por favor, tente novamente ou contacte-nos diretamente por telefone ou e-mail.',
    },

    ourBlog: {
        subtitle: 'NOSSO BLOG',
        title: 'Últimas Notícias',
        viewAllNews: 'Ver Todas as Notícias',
    },

    aboutUsPage: {
        parentPage: 'Início',
        activePage: 'Empresa',
        motherMenu: 'Sobre Nós',
        testimonialSubtitle: 'TESTEMUNHO',
        testimonialTitle: 'O Que Dizem os Nossos Clientes',
    },

    aboutUsContent: {
        subtitle: 'SOBRE NÓS',
        title: 'O Seu Parceiro de Confiança na Gestão de Imóveis',
        description1: 'A Pure Key Homes é uma empresa profissional de gestão de imóveis baseada na Costa Cálida e Costa Blanca, Espanha. Especializamo-nos em proporcionar serviços completos de cuidado de imóveis para os proprietários, quer esteja a viver no estrangeiro ou simplesmente queira estar tranquilo sabendo que o seu imóvel está em mãos expertas.',
        description2: 'Com anos de experiência na gestão de imóveis, compreendemos os desafios únicos de manter um imóvel em Espanha. A nossa equipa multilingue fala inglês, espanhol e português, garantindo uma comunicação sem problemas com os proprietários de todo o mundo.',
        whyChoose: 'Por Que Nos Escolher?',
        professionalService: 'Serviço Profissional',
        professionalServiceDesc: 'Equipa experimentada dedicada a manter o seu imóvel segundo os mais altos padrões',
        availability247: 'Disponibilidade 24/7',
        availability247Desc: 'Apoio 24 horas para emergências e coordenação de acesso ao imóvel',
        multilingualTeam: 'Equipa Multilingue',
        multilingualTeamDesc: 'Fluentes em inglês, espanhol, francês e português para uma comunicação sem problemas',
        localExpertise: 'Conhecimento Local',
        localExpertiseDesc: 'Conhecimento profundo da gestão de imóveis na Costa Cálida e Costa Blanca',
        ourMission: 'A Nossa Missão',
        ourMissionDesc: 'Proporcionar serviços excepcionais de gestão de imóveis que deem aos proprietários uma tranquilidade completa, garantindo que os seus imóveis sejam mantidos, seguros e prontos quando os precisarem.',
        ourVision: 'A Nossa Visão',
        ourVisionDesc: 'Ser a empresa de gestão de imóveis mais confiável e fiável na região, conhecida pelo seu profissionalismo, transparência e dedicação à satisfação do cliente.',
    },

    counter: {
        guestsHosted: 'Hóspedes Atendidos',
        reservationsManaged: 'Reservas Gestionadas',
        propertiesManaged: 'Imóveis Gestionados',
        yearsOfExperience: 'Anos de Experiência',
        starRating: 'Classificação',
    },

    story: {
        subtitle: 'A NOSSA HISTÓRIA',
        title: 'A História da Pure Key Homes',
        theIdea: 'A Ideia',
        theIdeaDesc: 'A Ana era a directora de um hotel de cinco estrelas em Lisboa, Portugal, e o Pedro era um programador. Durante umas férias em La Manga, apaixonam-se rapidamente pela qualidade de vida e pelo potencial da região. O que começou como umas férias rapidamente tornou-se numa visão para o futuro.',
        businessConception: 'Conceção do Negócio',
        businessConceptionDesc: 'Combinando a experiência da Ana em hotelaria com o conhecimento tecnológico do Pedro, começaram a dar forma a um conceito profissional de gestão de imóveis. Esta colaboração marcou o nascimento oficial da Pure Key Homes.',
        legalSetup: 'Configuração Legal e Operacional',
        legalSetupDesc: 'O foco deslocou-se para o cumprimento legal, os processos operacionais e os padrões de serviço, garantindo que cada imóvel seria gestionado de forma transparente, segura e profissional.',
        growth: 'Crescimento e Infraestrutura',
        growthDesc: 'Com uma base sólida no lugar, a Pure Key Homes expandiu a sua infraestrutura, tecnologia e rede de serviços, oferecendo uma gestão fiável de imóveis de La Manga até Torre de la Horadada.',
    },

    serviceArea: {
        subtitle: 'ÁREA DE SERVIÇO',
        title: 'Operamos em toda a Costa Blanca Sul e Costa Cálida',
        specialCoverage: 'Com cobertura especial em:',
    },

    teamSection: {
        subtitle: 'A NOSSA EQUIPA',
        title: 'Conheça a Nossa Equipa',
        ana: 'Ana',
        anaSub: 'CEO',
        pedro: 'Pedro',
        pedroSub: 'Gerente e Programador',
        marco: 'Marco',
        marcoSub: 'Colaborador Chave',
    },

    servicesPage: {
        parentPage: 'Início',
        activePage: 'Nossos Serviços',
        motherMenu: 'Serviços',
        testimonialSubtitle: 'TESTEMUNHO',
        testimonialTitle: 'O Que Dizem os Nossos Clientes',
        close: 'Fechar',
        propertyManagement: 'Gestão de Imóveis',
        propertyManagementShort: 'Soluções completas de cuidado e manutenção do seu imóvel',
        propertyManagementDetail: 'O nosso serviço completo de gestão de imóveis garante que o seu imóvel seja mantido segundo os mais altos padrões. Tratamos de todos os aspectos do cuidado do imóvel, incluindo manutenção regular, reparações, coordenação com fornecedores e resposta a emergências.',
        keyHolding: 'Guarda de Chaves',
        keyHoldingShort: 'Armazenamento seguro de chaves e gestão de acesso ao imóvel',
        keyHoldingDetail: 'Proporcionamos serviços seguros de guarda de chaves, garantindo o acesso autorizado ao seu imóvel quando necessário. A nossa equipa profissional mantém protocolos de segurança estritos e registos de acesso detalhados.',
        meetAndGreet: 'Receção de Hóspedes',
        meetAndGreetShort: 'Serviço profissional de boas-vindas para os seus hóspedes e visitantes',
        meetAndGreetDetail: 'Cause uma excelente primeira impressão com o nosso serviço personalizado de receção. Recebemos os seus hóspedes, proporcionamos orientação sobre o imóvel, entregar as chaves e garante-se que tenham tudo o que precisam para uma estadia confortável.',
        cleaningService: 'Serviço de Limpeza',
        cleaningServiceShort: 'Serviços profissionais de limpeza para o seu imóvel',
        cleaningServiceDetail: 'O nosso serviço de limpeza minucioso garante que o seu imóvel esteja impecável e acolhedor. Oferecemos horários de limpeza regular, limpeza profunda e limpeza de mudança entre hóspedes.',
        laundryService: 'Serviço de Lavandaria',
        laundryServiceShort: 'Serviços completos de lavandaria e cuidado de roupa',
        laundryServiceDetail: 'Proporcionamos serviços completos de lavandaria incluindo lavagem, secagem, passagem a ferro e preparação de roupa de cama fresca.',
        propertyCheck: 'Revisão do Imóvel',
        propertyCheckShort: 'Inspeções e monitorização regular do imóvel',
        propertyCheckDetail: 'O nosso serviço de revisão do imóvel inclui inspeções regulares para identificar e resolver potenciais problemas antes de se tornarem problemas. Verificamos fugas de água, problemas elétricos, preocupações de segurança e necessidades de manutenção geral.',
        alarmResponse: 'Resposta a Alarmes',
        alarmResponseShort: 'Serviço de resposta a alarmes de emergência 24/7',
        alarmResponseDetail: 'O nosso serviço de resposta a alarmes proporciona acção imediata quando o alarme do seu imóvel é ativado. Disponível 24/7, a nossa equipa vai ao seu imóvel, contacta as empresas de segurança e os serviços de emergência e toma as medidas apropriadas para garantir a segurança do seu imóvel.',
        registerGuests: 'Registo de Hóspedes',
        registerGuestsShort: 'Assistência no registo e check-in de hóspedes',
        registerGuestsDetail: 'Tratamos de todos os aspectos do registo de hóspedes incluindo os procedimentos oficiais de check-in, documentação e comunicação às autoridades locais conforme requerido pela lei espanhola.',
        upholsteryCleaning: 'Limpeza de Estofamento',
        upholderyCleaningShort: 'Limpeza profunda de mobília e estofamento',
        upholsteryCleaningDetail: 'O nosso serviço especializado de limpeza de estofamento revitaliza a sua mobília, removendo manchas, odores e alérgenos. Utilizamos equipamento e técnicas profissionais adequadas para diferentes tecidos e materiais.',
        mortgageServices: 'Serviços de Hipoteca',
        mortgageServicesShort: 'Assistência com hipotecas e serviços financeiros españois',
        mortgageServicesDetail: 'Navegue pelo mercado de hipotecas españois com a nossa orientação experta. Conectamo-lo com assessores financeiros e corretores de hipotecas de confiança que compreende os requisitos únicos para os proprietários estrangeiros.',
        support247: 'Apoio 24x7',
        support247Short: 'Disponibilidade 24 horas para todas as suas necessidades',
        support247Detail: 'O nosso compromisso com você não para fora das horas de escritório. Proporcionamos apoio 24/7 para emergências, pedidos urgentes e tranquilidade. Seja uma emergência de manutenção, um problema com um hóspede ou simplesmente uma pergunta, a nossa equipa está sempre disponível para ajudar.',
    },

    pricingPage: {
        parentPage: 'Início',
        activePage: 'Nossos Preços',
        motherMenu: 'Preços',
        testimonialSubtitle: 'TESTEMUNHO',
        testimonialTitle: 'O Que Dizem os Nossos Clientes',
    },

    teamPage: {
        parentPage: 'Início',
        activePage: 'A Nossa Equipa',
        motherMenu: 'Equipa',
        testimonialSubtitle: 'TESTEMUNHO',
        testimonialTitle: 'O Que Dizem os Nossos Clientes',
    },

    faqPage: {
        parentPage: 'Início',
        activePage: 'FAQ',
        motherMenu: 'FAQ',
        subtitle: 'FAQ',
        title: 'Perguntas Frequentes',
        faq2Subtitle: 'FAQ',
        faq2Title: 'Guia de Gestão de Imóveis',
        faq2Desc: 'Tudo o que precisa de saber sobre a gestão do seu imóvel com a Pure Key Homes.',
        categoryGeneral: 'Gestão Geral de Imóveis',
        categoryServices: 'Serviços aos Hóspedes & Gestão',
        categoryPricing: 'Começar & Preços',
        testimonialSubtitle: 'TESTEMUNHOS',
        testimonialTitle: 'O Que Dizem os Nossos Clientes',

        q1: 'Que áreas cobrem?',
        a1: 'Operamos na Costa Cálida e Costa Blanca, com cobertura especial em Los Alcázares, Torre Pacheco, San Javier, Santiago de la Ribera, La Manga, Pilar de la Horadada e Torre de la Horadada.',

        q2: 'Que serviços estão incluídos na gestão completa do imóvel?',
        a2: 'A nossa gestão completa inclui comunicação com os hóspedes antes, durante e depois da estadia, serviço de receção, guarda de chaves, limpeza profissional e lavandaria entre estadias, verificações do imóvel, coordenação de manutenção, apoio de emergência 24/7 e relatórios detalhados.',

        q3: 'Como tratam as emergências?',
        a3: 'Proporcionamos serviço de resposta a emergências 24/7. A nossa equipa no local pode comparecer imediatamente para situações urgentes como fugas de água, problemas elétricos ou questões de segurança. Coordenamos com serviços de emergência e empreiteiros locais conforme necessário e mantemos-vos informados.',

        q4: 'Posso personalizar os serviços que preciso?',
        a4: 'Absolutamente! Oferecemos pacotes de serviços flexíveis. Quer precise apenas de guarda de chaves, limpeza entre hóspedes ou gestão completa do imóvel, podemos adaptar os nossos serviços às suas necessidades e orçamento específicos.',

        q5: 'Com que frequência inspecionam o meu imóvel?',
        a5: 'Para imóveis de aluguer, inspecionamos antes e depois de cada estadia. Para imóveis não alugados, podemos agendar verificações regulares semanalmente, quinzenalmente ou mensalmente conforme a sua preferência. Cada inspeção inclui um relatório detalhado com fotografias.',

        q6: 'Vocês tratam do check-in e check-out dos hóspedes?',
        a6: 'Sim! Proporcionamos um serviço pessoal de receção, damos as boas-vindas aos hóspedes à chegada, mostramos-lhes o imóvel, explicamos como tudo funciona e estamos disponíveis durante toda a estadia. Também tratamos das inspeções de check-out e recolha de chaves.',

        q7: 'Que idiomas fala a sua equipa?',
        a7: 'A nossa equipa multilingue fala inglês, espanhol, português e francês, garantindo uma comunicação fluida com proprietários e hóspedes de todo o mundo.',

        q8: 'Vocês gerem reservas de plataformas como Airbnb e Booking.com?',
        a8: 'Sim, podemos gerir os vossos anúncios em todas as principais plataformas incluindo Airbnb, Booking.com e Vrbo. Tratamos da comunicação com hóspedes, sincronização de calendários, otimização de preços e garantimos conformidade com todos os requisitos das plataformas.',

        q9: 'O que inclui o vosso serviço de limpeza?',
        a9: 'A nossa limpeza profissional inclui limpeza completa de todas as divisões, eletrodomésticos de cozinha, casas de banho, pisos, superfícies, limpeza de janelas e remoção de lixo. Também fornecemos roupa de cama e toalhas limpas, e garantimos que o imóvel está pronto para hóspedes com todas as comodidades.',

        q10: 'Com que rapidez conseguem arranjar manutenção ou reparações?',
        a10: 'Trabalhamos com empreiteiros locais de confiança e normalmente conseguimos arranjar reparações urgentes em 24 horas. Para manutenção não urgente, coordenamos convosco primeiro e fornecemos orçamentos antes de proceder. Todo o trabalho é supervisionado e documentado.',

        q11: 'Como posso começar?',
        a11: 'Simplesmente contacte-nos por telefone, email ou o formulário de contacto do nosso website. Marcaremos uma reunião para discutir as vossas necessidades, visitar o vosso imóvel e criar um plano de serviços personalizado. Normalmente conseguimos integrar novos imóveis em 48 horas.',

        q12: 'Há um contrato ou compromisso mínimo?',
        a12: 'Oferecemos acordos flexíveis com base nas vossas necessidades. Para gestão completa de imóveis, normalmente trabalhamos com acordos trimestrais. Para serviços individuais como limpeza ou guarda de chaves, não é necessário compromisso a longo prazo.',

        q13: 'Como vou receber relatórios sobre o meu imóvel?',
        a13: 'Receberá relatórios detalhados por email após cada verificação do imóvel, estadia de hóspedes ou visita de manutenção. Os relatórios incluem fotografias, notas sobre a condição do imóvel, quaisquer problemas encontrados e ações tomadas. Pode também solicitar atualizações a qualquer momento.',

        q14: 'Quais são as vossas taxas de serviço?',
        a14: 'Os nossos preços dependem dos serviços que precisa e do tamanho do seu imóvel. Oferecemos tarifas transparentes e competitivas sem taxas ocultas. Contacte-nos para um orçamento personalizado com base nos seus requisitos específicos.',

        q15: 'Estão segurados e licenciados?',
        a15: 'Sim, estamos totalmente segurados e operamos em conformidade com todas as regulamentações espanholas de gestão de imóveis. Mantemos seguro de responsabilidade profissional e trabalhamos com empreiteiros licenciados para todos os serviços especializados.',
    },

    blogListPage: {
        parentPage: 'Início',
        activePage: 'Nosso Blog',
        motherMenu: 'Blog',
    },

    blogDetailPage: {
        parentPage: 'Início',
        activePage: 'Detalhes do Blog',
        motherMenu: 'Blog',
        relatedBlog: 'Blog Relacionado',
        relatedBlogSubtitle: 'NOSSO BLOG',
        postReview: 'REVISÃO',
        comments: 'Comentários',
        reply: 'Responder',
        replyNow: 'RESPONDER AGORA',
        leaveAReply: 'Deixe uma Resposta',
        firstName: 'Nome',
        lastName: 'Apelido',
        emailAddress: 'Endereço de Correio Eletrónico',
        message: 'Mensagem',
        postNow: 'Publicar Agora',
        tag: 'Etiqueta:',
        formSuccess: 'Bem feito!',
        formSuccessText: 'formulário enviado com sucesso',
    },

    contactPage: {
        parentPage: 'Início',
        activePage: 'Contacto',
        motherMenu: 'Contacto',
        callNow: 'Ligue Agora',
        location: 'Localização',
        emailAddress: 'Endereço de Correio Eletrónico',
    },

    blogSidebar: {
        search: 'Procurar',
        searchPlaceholder: 'Procurar...',
        recentPost: 'Publicações Recentes',
        category: 'Categoria',
        advertising: 'Publicidade',
        tags: 'Etiquetas',
        gallery: 'Galeria',
    },

    blogCard: {
        readMore: 'LER MAIS',
    },

    loginPage: {
        backToSite: 'Voltar ao Site',
        welcomeBack: 'Bem-vindo de Volta',
        signInToAccount: 'Entre na sua conta',
        continueWithGoogle: 'Continuar com Google',
        continueWithMicrosoft: 'Continuar com Microsoft',
        or: 'OU',
        loginWithEmail: 'Entrar com E-mail e Senha',
        emailAddress: 'Endereço de E-mail',
        password: 'Senha',
        forgotPassword: 'Esqueceu a senha?',
        signIn: 'Entrar',
        signingIn: 'A entrar...',
    },
};

export default pt;
